import * as styles from "./TextAndImageCardSquare.module.scss";

import React from "react";

import clip from "text-clipper";
import FuzzyBorder from "../../../../components/borders/FuzzyBorder";
import { Button } from "../../../../components/common";
import ProcessedImage from "../../../../components/common/ProcessedImage/ProcessedImage";
import { Colours } from "../../../../utils/colours";

const MAX_CHARACTER_COUNT = 100;
export interface TextAndImageCardSquareProps {
	title: string;
	text: string;
	buttonText: string;
	buttonUrl: string;
	imgSrc: string;
	imgAlt: string;
	jumpLinksTitle?: string;
}
export const TextAndImageCardSquare: React.FC<TextAndImageCardSquareProps> = ({
	imgSrc,
	imgAlt,
	text,
	title,
	buttonText,
	buttonUrl,
	jumpLinksTitle,
}) => {
	const getShortText = () => {
		if (text.length > MAX_CHARACTER_COUNT)
			return `${clip(text, MAX_CHARACTER_COUNT, {
				html: true,
			})}`;
		return text;
	};
	return (
		<article className={styles.textandimagecardcontainer}>
			<div className={styles.image}>
				<ProcessedImage
					src={imgSrc}
					dimensions="400x300"
					width={368}
					height={276}
					alt={imgAlt}
					loading={"lazy"}
				/>
				<div className={styles.bordercontainer}>
					<FuzzyBorder
						className={styles.border}
						rotation={0}
						fill={Colours.SUNSHINE_YELLOW}
					/>
				</div>
			</div>
			<div className={styles.details}>
				{jumpLinksTitle ? (
					<h3 className={styles.title} data-jumplinkstitle={jumpLinksTitle}>
						{title}
					</h3>
				) : (
					<h3 className={styles.title}>{title}</h3>
				)}
				<div
					className={styles.text}
					// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
					dangerouslySetInnerHTML={{ __html: getShortText() }}
				/>
				<div className={styles.buttonwrapper}>
					<Button fullWidth={true} variant={"secondary"} url={buttonUrl}>
						{buttonText}
					</Button>
				</div>
			</div>
		</article>
	);
};

export default TextAndImageCardSquareProps;
